export default __webpack_public_path__ + "static/media/html.ad6122b6.svg";